// extracted by mini-css-extract-plugin
module.exports = {"icon":"y18uW"};